module.exports = __webpack_public_path__ + "img/6_50.ef2a3aff.png";